<template>
    <div>
        <vs-row>
            <vs-col vs-w="12">
                <vs-divider position="left" class="mt-10 font-bold"><p class="bold">Taux de réponses: {{ Math.round(resource.ratings.length / resource.affected_users_count * 100) }}%</p></vs-divider>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <span>Taux de réponses totales: {{ Math.round(resource.ratings_with_all_closed_questions_replied / resource.ratings.length * 100) }}%</span>
                    </div>
                    <div class="vx-col w-full">
                        <span>Taux de réponses partielles: {{ Math.round(100 - (resource.ratings_with_all_closed_questions_replied / resource.ratings.length * 100)) }}%</span>
                    </div>
                </div>

                <vs-divider position="left" class="mt-10 font-bold"><p class="bold">Pourcentage d'appréciations globales: 88%</p></vs-divider>

                <template v-for="(response, question) in resource.synthesis_v0_from_ia_with_file">
                    <vs-divider position="left" class="mt-10 font-bold"><p class="bold">{{ question }} :</p></vs-divider>
                    <div class="vx-row mb-6">
                        <div class="vx-col w-full" v-html="response"></div>
                    </div>
                </template>

                <vs-divider position="left" class="mt-10 font-bold"><p class="bold">Synthèse des questions fermées :</p></vs-divider>

                <div v-for="(grid, i) in grids" :key="'table_grid_'+i" class="mb-10">
                    <vs-table
                        style="width:100%"
                        :no-data-text="``"
                        :data="grid.closed_questions"
                    >
                        <template slot="header"><h4 class="mb-1">{{ grid.title }}</h4></template>
                        <template slot="thead">
                            <vs-th >Question</vs-th>
                            <vs-th>Sans avis</vs-th>
                            <vs-th v-for="(param, p) in ratingParams" :key="'head_param'+p">
                                {{ param.label }}
                            </vs-th>
                            <vs-th>Taux de réponses</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr v-for="(closed_question, j) in data" :key="'grid_'+i+'_closed_question_'+j">
                                <vs-td class="center" >{{ closed_question.title }}</vs-td>
                                <vs-td class="center"><div :class="'colored-block '+colors[0]">{{ closed_question.param_0 / closed_question.all_param * 100 }}%</div></vs-td>
                                <vs-td class="center" v-for="(param, p) in ratingParams" :key="'body_param'+p">
                                    <div :class="'colored-block '+colors[param.id]">{{ closed_question['param_'+param.id] / closed_question.all_param * 100 }}%</div>
                                </vs-td>
                                <vs-td class="center"><div class="colored-block white">{{ resource.ratings ? (closed_question.leveled_params / (resource.ratings.length) * 100) : 'NA' }}%</div></vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        value: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            log: console.log,
            resource: {},
            colors: [
                'gray',
                'red',
                'orange',
                'green',
                'blue'
            ]
        };
    },
    created() {
        this.initResource();
        console.log('V0 Resource', window._.cloneDeep(this.resource))
    },
    computed: {
        appSettings() {
            return window.Laravel.settings;
        },

        ratingSettings() {
            return this.appSettings.find(el => el.name === "ratings").value;
        },

        ratingParams() {

            if (this.ratingSettings &&
                this.ratingSettings.paramsOccSkill &&
                this.ratingSettings.meaningNotes
            ) {
                let plop = Object.keys(this.ratingSettings.paramsOccSkill).map(id => {
                    let param = this.ratingSettings.paramsOccSkill[id];
                    param.id = id;
                    param.description = this.ratingSettings.meaningNotes[id - 1];
                    return param;
                });
                console.log('param 1', plop)
                return plop;

            } else if (this.ratingSettings && this.ratingSettings.params) {

                let plop = Object.keys(this.ratingSettings.params).map(id => {
                    let param = this.ratingSettings.params[id];
                    param.id = id;
                    return param;
                });
                console.log('param 2', plop)
                return plop;
            }

            return [];
        },

        grids() {
            let grids = window._.cloneDeep(this.resource.grids)
            grids.forEach(grid => {
                grid.closed_questions = []
                grid.occupation_skills?.forEach(occupation_skill => {
                    //Ajout de statistiques pour lecture
                    let all_params = 0
                    let leveled_params = 0
                    occupation_skill['param_'+0] = this.resource.closed_questions.filter(cq => cq.occupation_skill_id == occupation_skill.id && cq.level == null).length
                    all_params += occupation_skill['param_'+0]
                    this.ratingParams.forEach(param => {
                        occupation_skill['param_'+param.id] = this.resource.closed_questions.filter(cq => cq.occupation_skill_id == occupation_skill.id && cq.level == param.id).length
                        all_params += occupation_skill['param_'+param.id]
                        leveled_params += occupation_skill['param_'+param.id]
                    })
                    occupation_skill['all_param'] = all_params;
                    occupation_skill['leveled_params'] = leveled_params;

                    grid.closed_questions.push(occupation_skill)
                })
                grid.admin_occupation_skills?.forEach(occupation_skill => { //TODO: cq.admin_occupation_skill_id == occupation_skill.id ???? ou admin_id ??? autre ???
                    //Ajout de statistiques pour lecture
                    let all_params = 0
                    let leveled_params = 0
                    occupation_skill['param_'+0] = this.resource.closed_questions.filter(cq => cq.admin_occupation_skill_id == occupation_skill.id && cq.level == null).length
                    all_params += occupation_skill['param_'+0]
                    this.ratingParams.forEach(param => {
                        occupation_skill['param_'+param.id] = this.resource.closed_questions.filter(cq => cq.admin_occupation_skill_id == occupation_skill.id && cq.level == param.id).length
                        all_params += occupation_skill['param_'+param.id]
                        leveled_params += occupation_skill['param_'+param.id]
                    })
                    occupation_skill['all_param'] = all_params;
                    occupation_skill['leveled_params'] = leveled_params;

                    grid.closed_questions.push(occupation_skill)
                })
            })

            console.log('Grids', window._.cloneDeep(grids))
            return grids
        }


    },
    watch: {},
    methods: {
        initResource() {
            console.log('Value', window._.cloneDeep(this.value))
            this.resource = window._.cloneDeep(this.value);
            let closedQuestions = []
            this.resource.ratings.forEach(rating => {
                rating.occupation_skills?.forEach(occupation_skill => {

                    closedQuestions.push(occupation_skill)
                })
                rating.admin_occupation_skills?.forEach(occupation_skill => {
                    closedQuestions.push(occupation_skill)
                })
            })
            this.resource.closed_questions = closedQuestions
            this.resource.ratings_with_all_closed_questions_replied = this.resource.ratings.filter(rating => {
                return rating.occupation_skills.filter(os => os.level != null).length === rating.occupation_skills.length
            }).length
        },
    }
};
</script>
<style scoped>
.colored-block {
    border-radius: 5px;
    padding: 5px;
    text-align: center;
    width: 50px;
    color: white;
    font-weight: bold;

    &.gray {
        background-color: #cbcbcb;
    }
    &.red {
        background-color: #eb3425;
    }
    &.orange {
        background-color: #f7cd47;
    }
    &.green {
        background-color: #abda6b;
    }
    &.blue {
        background-color: #53baf8;
    }
    &.white {
        background-color: #ffffff;
        color: black;
    }
}
.vs-table--tbody-table .tr-values td:first-child {
    min-width: 525px;
    max-width: 525px;
    width: 525px;
}
</style>
